import React, { createContext, useEffect, useState } from 'react';
import { getRecordingsAPI } from '../services/api';

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [recordings, setRecordings] = useState([]);

  useEffect(() => {
    const storedUser = localStorage.getItem('liveclass_user');
    if (storedUser) {
      try {
        const parsed = JSON.parse(storedUser);
        setUser(parsed);
      } catch {
        // ignore
      }
    }
  }, []);

  useEffect(() => {
    if (!user) return;
    (async () => {
      try {
        const data = await getRecordingsAPI(user.id);
        setRecordings(data);
      } catch (err) {
        console.error('Error loading recordings', err);
      }
    })();
  }, [user]);

  const addRecording = (rec) => {
    setRecordings((prev) => [rec, ...prev]);
  };

  const value = {
    user,
    setUser,
    recordings,
    addRecording,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
